import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {
  ActivatedRoute,
  Router,
  RouterState,
  RouterStateSnapshot
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppSettings } from '~shared/constants/app-settings';
import { MensajesRespuestas } from '~shared/constants/mensajeRespuesta';
import { Ciudad } from '~shared/models/ciudad';
import { Registro, RegistroUsuarios } from '~shared/models/registro';
import { CiudadesService } from '~shared/servicios/ciudades.service';
import { UsuariosService } from '~shared/servicios/usuarios.service';
import { RegistroTienda } from './../../../shared/models/registro';

@Component({
  selector: 'app-tiendas-movil',
  templateUrl: './tiendas-movil.component.html',
  styleUrls: ['./tiendas-movil.component.scss']
})
export class TiendasMovilComponent implements OnInit {

  @ViewChild('stepper') stepper;
  isLinear = true;
  registroFormGroup1: FormGroup;
  registroFormGroup2: FormGroup;
  registroFormGroup3: FormGroup;
  registroFormGroup4: FormGroup;
  ciudadSelected: Ciudad;
  idLider: string;
  lider: { id_lider: string; lider: '' };
  succes = false;

  optionsCiudades: Ciudad[];
  filteredOptions: Observable<Ciudad[]>;

  paises;
  selectPais;

  Cities: any[];
  isVisible: boolean;
  opcNosotros: any[] = ["0-50", "50-200", "200-400", "400-800", "800-1500", "1500-3000"];
  nosoSelected: string;

  video: any;
  mensaje: any = 'Loading...';

  usuarioModal = { nombreT: '', correo: '' };
  disabledInps: boolean = false;

  hidePass = true;

  constructor(
    private formBuilder: FormBuilder,
    private ciudadesService: CiudadesService,
    private usuarioService: UsuariosService,
    private SpinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.isVisible = true;
    this.cargarLider();
  }

  ngOnInit(): void {
    if (sessionStorage.getItem(btoa('correoReg-tienda')) !== null || sessionStorage.getItem(btoa('nombreReg-tienda')) !== null) {
      this.usuarioModal.nombreT = atob(sessionStorage.getItem(btoa('nombreReg-tienda')));
      this.usuarioModal.correo = atob(sessionStorage.getItem(btoa('correoReg-tienda')));
      this.disabledInps = (atob(sessionStorage.getItem(btoa('disabledInp-tienda'))) === 'true');
      this.createForm();
      this.loadPaises();
    } else {
      // this.router.navigate(['/']);
      this.createForm();
      this.loadPaises();
    }
  }

  cargarLider(): void {
    this.activatedRoute.params.subscribe(() => {
      const state: RouterState = this.router.routerState;
      const snapshot: RouterStateSnapshot = state.snapshot;
      if (sessionStorage.getItem('Tienda')) {
        // console.log('Si existe!', sessionStorage.getItem('Tienda'));
        this.idLider = sessionStorage.getItem('Tienda');
      } else {
        if (this.activatedRoute.snapshot.params.id) {
          this.idLider = this.activatedRoute.snapshot.params.id;
        } else {
          this.idLider = AppSettings.LIDER_DEFAULT;
        }
      }
      this.loadInfoLider();
    });
  }

  descarga(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  loadInfoLider(): void {
    this.usuarioService.getLider(this.idLider).subscribe((response) => {
      if (response) {
        this.lider = response[0];
      }
    }, (err) => {
      sessionStorage.removeItem('Tienda');

      this.cargarLider();

    });
  }

  //CREA EL FORMULARIO
  createForm(): void {
    this.registroFormGroup1 = this.formBuilder.group({
      nombreTienda: [{ value: this.usuarioModal ? this.usuarioModal?.nombreT : '', disabled: this.disabledInps }, [Validators.required, Validators.maxLength(45), Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+(?: [a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+)*$')]],
      email: [
        {
          value: this.usuarioModal ? this.usuarioModal?.correo : '', disabled: this.disabledInps
        },
        [Validators.required, Validators.maxLength(60), Validators.email],
      ],
      direccion: ['', [Validators.required, Validators.maxLength(45), Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 #-]*')]],
      pais: [''],
      ciudad: ['', Validators.required],
      telefono: [''/*, [Validators.required, Validators.maxLength(12)]*/],
      cedula: [''/*, [Validators.required, Validators.maxLength(12)]*/],
    });
    this.registroFormGroup2 = this.formBuilder.group({
      nombreCompletoAdm: ['', [Validators.required, Validators.maxLength(45), Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+(?: [a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+)*$')]],
      usuarioAdm: [
        '',
        [
          Validators.required,
          Validators.maxLength(15),
          Validators.pattern('[a-zA-Z0-9]*'),
          this.validatorUsuario(),
        ],
      ],
      telefonoAdm: [''/*, [Validators.required, Validators.maxLength(12)]*/],
      celularAdm: ['', [Validators.required, Validators.maxLength(10)]],
      claveAdm: ['', [Validators.required, , Validators.pattern('^[a-zA-Z0-9$@$!%*?&.#]+$')]],
    });
    this.registroFormGroup3 = this.formBuilder.group({
      nombreContacto: ['' /*, [Validators.required, Validators.maxLength(45), Validators.pattern('[a-zA-Z ]*')]*/],
      celularContacto: [''/*, [Validators.required, Validators.maxLength(12)]*/],
    });
    this.registroFormGroup4 = this.formBuilder.group({
      totalVentas: ['' /*, [Validators.required]*/],
      comoNosotros: ['', [Validators.required, Validators.maxLength(45), Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+(?: [a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+)*$')]],
    });
  }

  //DESMARCA LOS ERRORES EN LOS CAMPOS
  private desmarcarErrorCampoForm1(control: string, group: number): void {
    /* tslint:disable */
    if (group === 1)
      return this.registroFormGroup1.get(control).setErrors(null);
    if (group === 2)
      return this.registroFormGroup2.get(control).setErrors(null);
    if (group === 3)
      return this.registroFormGroup3.get(control).setErrors(null);
    if (group === 4)
      return this.registroFormGroup3.get(control).setErrors(null);
    /* tslint:enable */
  }

  //VALIDA EL USUARIO
  private validatorUsuario(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!!this.registroFormGroup2) {
        const usuario = this.registroFormGroup2.get('usuarioAdm').value;
        if (usuario.indexOf(' ') >= 0) {
          this.registroFormGroup2.get('usuarioAdm').setErrors({ required: true });
        } else {
          if (usuario) {
            return this.usuarioService.getUsuario(usuario).subscribe((resp) => {
              if (resp) {
                const respuesta = resp[0];
                const comparacion = (MensajesRespuestas.REGISTRO_YA_EXISTE === respuesta.id_response);
                if (comparacion === true) {
                  //console.log("SE DEBE CAMBIAR");
                  this.registroFormGroup2.get('usuarioAdm').setErrors({ required: true });
                  return { requiredValue: true };
                } else {
                  this.desmarcarErrorCampoForm1('usuarioAdm', 2);
                  return null;
                }
              }
            });
          }
        }
      }
    };
    return null;
  }

  //OBTIENE CONTROL DE CADA PARTE DEL FORMULARIO
  getControl(control: string, group: number): AbstractControl {
    /* tslint:disable */
    if (group === 1) return this.registroFormGroup1.get(control);
    if (group === 2) return this.registroFormGroup2.get(control);
    if (group === 3) return this.registroFormGroup3.get(control);
    if (group === 4) return this.registroFormGroup4.get(control);
    /* tslint:enable */
  }

  loadPaises(): void {
    this.ciudadesService.getPaises().subscribe((dataPais) => {
      let pos;
      this.paises = dataPais;
      // console.log(this.paises);
      this.paises.find((elem, index) => {
        if (elem.pais === 'Colombia') {
          pos = index;
        }
      })
      this.selectPais = this.paises[pos];
      this.loadCiudades(this.selectPais.pais);
    });
  }

  selectPaisChange(e): void {
    // console.log('cambio', this.selectPais);
    this.loadCiudades(this.selectPais.pais);
  }

  //TRAE VALORES DE LA CIUDAD
  loadCiudades(country): void {
    this.ciudadesService.getCiudades(country).subscribe((ciudades) => {
      this.optionsCiudades = ciudades;
      this.Cities = ciudades;
      // console.log("Ciudades", this.Cities);

      this.addListeners();
    });
  }

  //TRAE VALORES DE LA CIUDAD
  addListeners(): void {
    this.filteredOptions = this.registroFormGroup1
      .get('ciudad')
      .valueChanges.pipe(
        startWith(''),
        map((value) => {
          return this.ciudadFilter(value);
        })
      );
  }

  //FILTRO DE CIUDAD
  private ciudadFilter(ciudad: string): Ciudad[] {
    ciudad = ciudad === null ? '' : ciudad;
    const filterValue = ciudad.toLowerCase();
    const filtered = this.optionsCiudades.filter((option) =>
      option.ciudad.toLowerCase().includes(filterValue)
    );
    if (filtered.length > 0) {
      return filtered;
    } else {
      this.registroFormGroup1.get('ciudad').setErrors({ required: true });
      return [];
    }
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOption(ciudad: Ciudad): void {
    this.ciudadSelected = ciudad;
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOption2(nosotros: string): void {
    this.nosoSelected = nosotros;
  }

  //SALVA TODA LA INFORMACION
  saveInfo(): void {
    this.SpinnerService.show();
    if (
      this.registroFormGroup1.valid &&
      this.registroFormGroup2.valid &&
      this.registroFormGroup3.valid &&
      this.registroFormGroup4.valid
    ) {
      const valueFOrmRegistro: Registro = {
        ...this.registroFormGroup1.value,
        ...this.registroFormGroup2.value,
        ...this.registroFormGroup3.value,
        ...this.registroFormGroup4.value,
      };

      valueFOrmRegistro.ciudadId = this.ciudadSelected.id_centro_logistico;
      const tienda = this.setObjectRegistroTienda(valueFOrmRegistro);
      // console.log(tienda);
      this.usuarioService.guardaTienda(tienda).subscribe((responseTienda) => {
        // this.SpinnerService.show();
        // console.log(responseTienda);
        if (responseTienda) {
          const usuario = this.setObjectRegistroUSuario(
            valueFOrmRegistro,
            responseTienda[0].id
          );
          // console.log(usuario)
          this.usuarioService
            .guardaUsuario(usuario)
            .subscribe((responseUsuaio) => {
              //console.log('este es el id tienda: ' + responseTienda[0].id);
              // console.log(responseUsuaio);
              this.succes = true;
              this.mensaje = 'Registro exitoso!';
              // ELIMINA DATOS DE SESSION
              sessionStorage.removeItem(btoa('nombreReg-tienda'));
              sessionStorage.removeItem(btoa('correoReg-tienda'));
              sessionStorage.removeItem(btoa('disabledInp-tienda'));
              setTimeout(() => {
                this.isVisible = false;
                window.location.href = "http://www.triidy.info";
                this.SpinnerService.hide();
              }, 4000);
              window.scroll(0, 0);
            });
        }
      });
    } else {
      setTimeout(() => {
        this.mensaje = 'Verifica la información';
        setTimeout(() => {
          this.SpinnerService.hide();
        }, 2000);
      }, 5000);
    }
  }

  //GUARDA DATOS DE USUARIO DE FORMULARIO TIENDA
  setObjectRegistroUSuario(
    valueFOrmRegistro: Registro,
    idTienda: string
  ): RegistroUsuarios {
    return {
      id_tienda: idTienda,
      rol: '1',
      usuario: valueFOrmRegistro.usuarioAdm,
      nombre: valueFOrmRegistro.nombreCompletoAdm,
      clave: valueFOrmRegistro.claveAdm,
      direccion: valueFOrmRegistro.direccion,
      celular: valueFOrmRegistro.celularAdm,
      email: this.usuarioModal?.correo ? this.usuarioModal?.correo : valueFOrmRegistro.email,
      placa: 'NA',
    };
  }

  //GUARDA DATOS REGISTRADOS DE TIENDA DEL FORMULARIO
  setObjectRegistroTienda(valueFOrmRegistro: Registro): RegistroTienda {
    return {
      id_lider: this.lider.id_lider,
      id_ciudad: this.ciudadSelected.id_centro_logistico,
      nombre_tienda: this.usuarioModal?.nombreT ? this.usuarioModal?.nombreT : valueFOrmRegistro.nombreTienda,
      direccion_tienda: valueFOrmRegistro.direccion,
      nit_tienda: '0',
      telefono_tienda: valueFOrmRegistro.celularAdm,
      email_tienda: this.usuarioModal?.correo ? this.usuarioModal?.correo : valueFOrmRegistro.email,
      nombre_contacto: valueFOrmRegistro.nombreCompletoAdm,
      telefono_contacto: valueFOrmRegistro.celularAdm,
      celular_contacto: valueFOrmRegistro.celularAdm,
      contacto_operativo: valueFOrmRegistro.nombreCompletoAdm,
      celular_operativo: valueFOrmRegistro.celularAdm,
      total_ventas: '10',
      como_se_entero: valueFOrmRegistro.comoNosotros,
    };
  }

  limpiarInfo() {
    this.stepper.reset();
    this.createForm();
    this.loadCiudades(this.selectPais.pais);
    this.registroFormGroup1.validator = null;
  }

  /* @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    const tienda = this.lider.lider;
    if (tienda.includes('Triidy')) {
      if (window.pageYOffset > 50) {
        let element = document.getElementById('navbar');
        element.classList.add('sticky');
      } else {
        let element = document.getElementById('navbar');
        element.classList.remove('sticky');
      }
    } else {
      // console.log('')
    }

  } */

}
